import { type BasePictureType } from '@/common/types/common';
import { type LotteryRewardName } from '@/common/types/lottery';

import usdPng from '/img/icons/usd-v2-large.png';
import usdWebp from '/img/icons/usd-v2-large.webp';
import blueLightPng from '/img/light/blue-light.png';
import blueLightWebp from '/img/light/blue-light.webp';
import goldLightPng from '/img/light/gold-light.png';
import goldLightWebp from '/img/light/gold-light.webp';
import greenLightPng from '/img/light/green-light.png';
import greenLightWebp from '/img/light/green-light.webp';
import greyLightPng from '/img/light/grey-light.png';
import greyLightWebp from '/img/light/grey-light.webp';
import purpleLightPng from '/img/light/purple-light.png';
import diamondPng from '/img/lottery/diamond.png';
import diamondWebp from '/img/lottery/diamond.webp';
import goldPng from '/img/lottery/gold.png';
import goldWebp from '/img/lottery/gold.webp';
import silverPng from '/img/lottery/silver.png';
import silverWebp from '/img/lottery/silver.webp';
import tgemPng from '/img/tgem-big.png';
import tgemWebp from '/img/tgem-big.webp';

const rewardsImage: Record<
  LotteryRewardName,
  { image: BasePictureType; light: BasePictureType }
> = {
  usdt: {
    image: {
      img: usdPng,
      webp: usdWebp,
      alt: 'usdt',
    },
    light: {
      img: greenLightPng,
      webp: greenLightWebp,
      alt: 'green light',
    },
  },
  tgem: {
    image: {
      img: tgemPng,
      webp: tgemWebp,
      alt: 'tgem',
    },
    light: {
      img: purpleLightPng,
      alt: 'purple light',
    },
  },
  silverTicket: {
    image: {
      img: silverPng,
      webp: silverWebp,
      alt: 'silver ticket',
    },
    light: {
      img: greyLightPng,
      webp: greyLightWebp,
      alt: 'grey light',
    },
  },
  goldTicket: {
    image: {
      img: goldPng,
      webp: goldWebp,
      alt: 'gold ticket',
    },
    light: {
      img: goldLightPng,
      webp: goldLightWebp,
      alt: 'grey light',
    },
  },
  diamondTicket: {
    image: {
      img: diamondPng,
      webp: diamondWebp,
      alt: 'diamond ticket',
    },
    light: {
      img: blueLightPng,
      webp: blueLightWebp,
      alt: 'grey light',
    },
  },
};

export { rewardsImage };
